import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchMyRISDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/my-ris/dropdown-filters`, postData);
        var resData = Object.assign({ type: 'SUCCESS_MYRIS_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchMyRISDetailAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/my-ris/kpi-page-data`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_MYRIS_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}


export {
    FetchMyRISDropdownAction,
    FetchMyRISDetailAction
}